// Unsaved themes are saved for the themes's id if editing a presentation
// or the themes's owner id if creating a new presentation.
export default function getUnsavedThemeId(theme: { id?: string }) {
  return theme?.id || 'new';
}
